<template>
    <form @submit.prevent="search()" id="manage-search" class="flex flex-col md:flex-row items-center w-full">
        <div class="manage-search-input-box relative w-full">
            <i class="fas fa-search absolute search-icon"></i>
            <input v-model="searchInput" class="manage-search-input w-full" />
        </div>
        <XButton
            :disabled="disabledSearch"
            type="submit"
            color="var(--text-color)"
            class="manage-search-button system-button-color system-button-text-color w-full md:w-auto shadow-text-none"
            aria-label="Search quiz"
        >
            {{ $t('manage_school_button_search') }}
        </XButton>
    </form>
</template>

<script>
import XButton from '@/components/v2/XButton'

export default {
    components: {
        XButton
    },

    props: {
        disabledSearch: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            searchInput: ''
        }
    },

    methods: {
        search() {
            if (this.disabledSearch) return

            this.$emit('search', this.searchInput.trim().replace(/\s+/g, ' '))
        },

        clear() {
            this.searchInput = ''
        }
    }
}
</script>

<style lang="scss">
#manage-search {
    row-gap: 1rem;

    .manage-search-input-box {
        color: #333;

        .search-icon {
            top: 50%;
            transform: translateY(-50%);
            left: 0.5rem;
        }

        .manage-search-input {
            height: 40px;
            border-radius: 0.25rem;
            padding: 10.5px 10.5px 10.5px 32px;
            border: 1px solid #ced4da;
            font-size: 14px;
            color: #333;

            @media screen and (min-width: 768px) {
                border-radius: 0.25rem 0 0 0.25rem;
            }
        }
    }

    .manage-search-button {
        border-radius: 0.25rem;

        @media screen and (min-width: 768px) {
            border-radius: 0 0.25rem 0.25rem 0 !important;
        }
    }
}
</style>